import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="h-16 flex items-center overflow-visible">
              <img
                src="https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/e8b5985a2853ff72499d68992cdf2c3a.png"
                alt="YourTime Logo"
                className="h-44 w-auto max-w-none"
              />
            </div>
            <p className="text-gray-400 text-sm">
              Crafting timeless elegance since 1985. Each watch is a masterpiece of precision and style.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-base font-semibold text-gray-900 mb-4">
              <a href="#quick-links" className="hover:text-gray-700">Quick Links</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/catalog" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Catalog</Link></li>
              <li><Link to="/customizer" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Customizer</Link></li>
              <li><Link to="/about" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-serif text-base font-semibold text-gray-900 mb-4">
              <a href="#support" className="hover:text-gray-700">Support</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/watch-care" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Maintenance</Link></li>
              <li><Link to="/shipping-returns" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Shipping &amp; Returns</Link></li>
              <li><Link to="/contact" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Contact Us</Link></li>
              <li><a href="#" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">FAQ</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-base font-semibold text-gray-900 mb-4">
              <a href="#contact-info" className="hover:text-gray-700">Contact Info</a>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-gray-600"></i>
                </div>
                <a href="mailto:yourtime.studio.shop@gmail.com" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer break-all">
                  yourtime.studio.shop@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-live-line text-gray-600"></i>
                </div>
                <div className="text-gray-600 text-sm">
                  <div className="font-medium">Live Stream Hours:</div>
                  <div>Wed - Sun: 5PM - 10PM PT</div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-line text-gray-600"></i>
                </div>
                <div className="text-gray-600 text-sm">
                  <div className="font-medium">Customer Service:</div>
                  <div>Mon - Sun: 10AM - 10PM PT</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © {currentYear} Your Time Studio. All rights reserved. <strong>Personalized watches</strong> crafted with precision.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="nofollow" className="text-gray-600 text-sm hover:text-gray-900 transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
